module.exports = __webpack_public_path__ + "img/work.bb1303bf.png";